import { isFeatureEnabled, FeatureName } from 'owa-feature-flags';
import type {
    OutlookSpaceAssetId,
    OutlookSpaceId,
    OutlookSpacesFilter,
    SyncParameters,
} from 'owa-timestream-types';

const apiVersions: [FeatureName, string][] = [
    ['outlookSpaces-v2_0-api', 'v2.0/spaces'], // v2 and v1 have higher precedence than v1.5
    ['outlookSpaces-v1_0-api', 'v1.0/spaces'], // so we can force these APIs that do not perform migration
    ['outlookSpaces-v1_5-api', 'v1.5/spaces'], // if we need to check anything.
];

function baseUri() {
    for (const [featureName, uri] of apiVersions) {
        if (isFeatureEnabled(featureName)) {
            return uri;
        }
    }

    return 'api/spaces';
}

export function spacesUri(spacesFilter?: OutlookSpacesFilter) {
    const appName = spacesFilter?.appName;
    const queryParam = appName ? '?appName=' + encodeURIComponent(appName) : '';
    return baseUri() + queryParam;
}

export function spaceUri(outlookSpaceId: OutlookSpaceId) {
    return baseUri() + '/' + encodeURIComponent(outlookSpaceId);
}

export function assetsUri(outlookSpaceId: OutlookSpaceId) {
    return spaceUri(outlookSpaceId) + '/assets';
}

export function assetUri(outlookSpaceId: OutlookSpaceId, assetId: OutlookSpaceAssetId) {
    return assetsUri(outlookSpaceId) + '/' + encodeURIComponent(assetId);
}

export function reorderChildrenUri(outlookSpaceId: OutlookSpaceId, assetId: OutlookSpaceAssetId) {
    return assetUri(outlookSpaceId, assetId) + '/reorderChildren';
}

export function recycleBinUri(outlookSpaceId: OutlookSpaceId) {
    return spaceUri(outlookSpaceId) + '/recycleBin';
}

export function syncAssetsUri(outlookSpaceId: OutlookSpaceId, syncParameters: SyncParameters) {
    const syncUrl = assetsUri(outlookSpaceId) + '/sync';

    const queryParams = (['skipToken', 'deltaToken', 'maxPageSize'] as (keyof SyncParameters)[])
        .map(k => (syncParameters[k] ? `${k}=${encodeURIComponent(syncParameters[k]!)}` : ''))
        .filter(x => x)
        .join('&');

    return syncUrl + (queryParams ? '?' + queryParams : '');
}
